// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"513f9105","460":"54476bb6"}[chunkId] + ".chunk.js";
};